import React from 'react';

import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';

import { PanelAction } from '../../panel-action/panel-action';
import type { PanelActionProps } from '../../panel-action/types';

export interface PanelActionMoreProps extends Pick<
	PanelActionProps,
	'onClick' | 'testId' | 'label'
> {}

/**
 * The PanelActionMore component provides a more actions dropdown button
 * for overflow actions in panel headers.
 */
export function PanelActionMore({
	onClick,
	testId,
	label,
}: PanelActionMoreProps): React.JSX.Element {
	return (
		<PanelAction
			onClick={onClick}
			testId={testId}
			spacing="compact"
			icon={ShowMoreHorizontalIcon}
			label={label || 'More actions'}
			aria-haspopup="menu"
		/>
	);
}
